import { Box, Button, Modal, Typography } from '@mui/material'
import { completeTaskGstrOne } from 'api/services/gstr/config';
import { exportErrorList } from 'api/services/reports';
import Loader from 'components/Loader';
import Table from 'components/Table';
import { snack } from 'components/toast';
import React, { useState } from 'react'
import { useMutation } from 'react-query';
import { handleError } from 'utils/handleError';
import * as XLSX from "xlsx";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


function SyncAtomPro({ selected }) {
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => {
    setOpenModal(!openModal);
  };
  let [errorsListModal, setErrorsListModal]: any = useState([]);
  let [completeTaskList, setCompleteTaskList]: any = useState([]);
  const { mutate: mutateCompleteGstrOne, isLoading: isLoadingCompleteTasks } = useMutation(completeTaskGstrOne, {
    onSuccess: (res: any) => {
      console.log(res?.data)

      // if (res?.data?.gstr1TasksCount) {
      //   snack.success(`${res?.data?.gstr1TasksCount} GSTR-1 tasks completed`,)
      // }
      // if (res?.data?.gstr3BTasksCount) {
      //   snack.success(`${res?.data?.gstr3BTasksCount} GSTR-3B tasks completed`,)
      // }

      // if (res?.data?.Gstr9TasksCount) {
      //   snack.success(`${res?.data?.Gstr9TasksCount} GSTR-9 tasks completed`,)
      // }

      // if (res?.data?.errorMsg) {
      //   res?.data?.errorMsg?.map((item) => {
      //     snack.error(item)
      //   }
      //   )
      // }

      if (res?.data?.gstCompletedTasks?.length > 0) {
        snack.success(`Sync Completed`)
        setCompleteTaskList(res?.data?.gstCompletedTasks)
        handleOpen();
      } else {
        snack.success(`No Task has been Updated`)
      }

      // if (res?.data?.successRows.length > 0) {
      //   setErrorsListModal(res?.data?.successRows)
      //   handleOpen();
      // }
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      completeTaskList?.map((item, index) => ({
        "S No": index + 1,
        "Task ID": item.taskNumber,
        "Task Name": item.name,
        "Client": item?.client?.displayName,
        "Status": item?.status
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet,);
    XLSX.writeFile(workbook, "gst-complete-task-list.xlsx");
  };

  const { mutate: getErrorFile, isLoading: loadingErrorFile } = useMutation(exportErrorList, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = file;
      link.download = "Completed Tasks.xlsx";
      link.click();
      snack.success("Exported successfully");
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const handleExport = () => {
    getErrorFile(errorsListModal);
  };

  const handleAtomProSync = () => {
    if (!selected.length) return snack.error('Select At least one Client');
    let clientDetails: any = []
    for (let i of selected) {
      if (i?.client?.id) {
        clientDetails.push(i?.client?.id);
      }
    }

    mutateCompleteGstrOne({ clientDetails })
  }

  const columns = [
    {
      key: "name",
      title: "Task Name",
      render: (item) => (
        <Typography >
          {item?.name}
        </Typography>
      ),
    },
    // `Task : ${item?.name} Task Number : ${item?.taskNumber} Client : ${item?.client?.displayName}
    {
      key: "type",
      title: "Task Id",
      render: (item) => {
        return (
          <Typography >
            {item?.taskNumber}
          </Typography>
        )
      },
    },
    {
      key: "id",
      title: "Client Name",
      render: (item) => (
        <Typography      >
          {item?.client?.displayName}
        </Typography>
      ),
    },
    {
      key: "id",
      title: "status",
      render: (v) => (
        <Typography >
          {v?.status}
        </Typography>
      ),
    }

  ];

  return (
    <>
      <Button
        onClick={() => handleAtomProSync()}
        variant="outlined"
        sx={{ ml: 2 }}
      >
        Sync With Atom
      </Button>

      {isLoadingCompleteTasks ? (
        <Modal
          open={isLoadingCompleteTasks}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              ...style,
              zIndex: "100",
              height: "30vh",
              width: "60vw",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              overflow: "auto",
            }}
          >
            <Typography textAlign={"center"} variant="h6">Atom Pro Sync Tasks</Typography>
            <Typography textAlign={"center"} sx={{ marginTop: "8px" }}>
              Thanks for your patience! We're currently Sync with Auto Pro.
              This may take a few minutes. Please wait...
            </Typography>
            <Loader minHeight={"70px"} />
          </Box>
        </Modal>
      ) : null}

      {!isLoadingCompleteTasks ? (
        <Modal
          open={openModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...style, maxHeight: "80vh", width: "70vw", overflow: "auto" }}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              Completed Task List
            </Typography>
            <Table
              sx={{ pb: 0, mb: 0, height: '450px' }}
              // pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
              data={completeTaskList || []}
              columns={columns}
            />
            <Box>
              <Button variant="outlined" color="secondary" sx={{ m: 2 }} onClick={handleClose}>
                Close
              </Button>
              <Button variant="outlined" color="secondary" onClick={exportToExcel}>
                Export to Excel
              </Button>
            </Box>
          </Box>
        </Modal>
      ) : null}



      {/* {!isLoadingCompleteTasks ? (
        <Modal
          open={openModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...style, maxHeight: "80vh", width: "70vw", overflow: "auto" }}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              Completed Task List
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              <ol>
                {errorsListModal.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ol>
            </Typography>
            <Box>
              <Button variant="outlined" color="secondary" sx={{ m: 2 }} onClick={handleClose}>
                Close
              </Button>
              <Button variant="outlined" color="secondary" onClick={handleExport}>
                Export to Excel
              </Button>
            </Box>
          </Box>
        </Modal>
      ) : null} */}
    </>
  )
}

export default SyncAtomPro